import { lazy, Suspense } from "react";
import { Header } from "@/components/Header";
import { HeroSection } from "@/components/HeroSection";
import { ProblemSection } from "@/components/ProblemSection";

// Below-the-fold sections — lazy loaded to reduce initial JS execution time
const HowItWorksSection = lazy(() =>
  import("@/components/HowItWorksSection").then((m) => ({ default: m.HowItWorksSection })),
);
const WhoWeServeSection = lazy(() =>
  import("@/components/WhoWeServeSection").then((m) => ({ default: m.WhoWeServeSection })),
);
const ClientLogosSection = lazy(() =>
  import("@/components/ClientLogosSection").then((m) => ({ default: m.ClientLogosSection })),
);
const ContactFormSection = lazy(() =>
  import("@/components/ContactFormSection").then((m) => ({ default: m.ContactFormSection })),
);
const GallerySection = lazy(() =>
  import("@/components/GallerySection").then((m) => ({ default: m.GallerySection })),
);
const FinalCTASection = lazy(() =>
  import("@/components/FinalCTASection").then((m) => ({ default: m.FinalCTASection })),
);
const Footer = lazy(() =>
  import("@/components/Footer").then((m) => ({ default: m.Footer })),
);
const StickyQuoteCTA = lazy(() =>
  import("@/components/StickyQuoteCTA").then((m) => ({ default: m.StickyQuoteCTA })),
);

const SectionFallback = () => <div className="min-h-[400px]" aria-hidden="true" />;

const Index = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <HeroSection />
      <ProblemSection />
      <Suspense fallback={<SectionFallback />}>
        <HowItWorksSection />
        <WhoWeServeSection />
        <ClientLogosSection />
        <ContactFormSection />
        <GallerySection />
        <FinalCTASection />
        <Footer />
        <StickyQuoteCTA />
      </Suspense>
    </div>
  );
};

export default Index;
